/**
 * @generated SignedSource<<f141e8f9ddd74338bd64ad27b0e07f03>>
 * @relayHash 2117e720949cfe5ff0567aed4ff232d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cd73558b61b6f87043dfd8085777f1bb529ce15ae97d53788fd25d84c4476050

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BranchDetailsPopupViewQuery } from './BranchDetailsPopupViewQuery.graphql';

const node: PreloadableConcreteRequest<BranchDetailsPopupViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "cd73558b61b6f87043dfd8085777f1bb529ce15ae97d53788fd25d84c4476050",
    "metadata": {},
    "name": "BranchDetailsPopupViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
